const quotationChat = {
  quotationChatNavLabel: "Chat de Cotação", // translated 
  quotationChatApprovalTitle: "Chat de Cotação", // translated 
  quotationChatAccountNotApprovedTitle: "Conta Não Aprovada", // translated 
  quotationChatAccountNotApprovedDescription:
    "Sua conta ainda não foi aprovada. Entre em contato com seu gerente de conta para obter mais informações.", // translated 
  quotationChatViewAiChat: "Ver Chat de I.A.", // translated 

  quotationRequestChatSessions: "Sessões de Chat", // translated 
  quotationRequestChatNoPastSessions: "Nenhuma sessão anterior", // translated 
  quotationRequestChatNewChat: "Novo Chat", // translated 
  quotationRequestChatCloseSidebar: "Fechar barra lateral", // translated 
  quotationRequestChatSessionFallback: "Sessão de Chat", // translated 
  quotationRequestChatDefaultSessionName: "Nova Sessão de Chat", // translated 
  quotationRequestChatTitle: "Chat de Solicitação de Cotação", // translated 
  quotationRequestChatResponseLanguageLabel: "Idioma da resposta", // translated 
  quotationRequestChatOpenSidebar: "Abrir barra lateral", // translated 
  quotationRequestChatRenameSession: "Renomear sessão", // translated 
  quotationRequestChatDeleteSession: "Excluir sessão", // translated 
  quotationRequestChatToggleDarkMode: "Alternar modo escuro", // translated 
  quotationRequestChatSwitchToLightMode: "Mudar para modo claro", // translated 
  quotationRequestChatSwitchToDarkMode: "Mudar para modo escuro", // translated 
  quotationRequestChatEmptyStateHeading: "Iniciar uma Nova Conversa de Solicitação de Cotação", // translated 
  quotationRequestChatEmptyStateSubheading:
    "Descreva suas necessidades de viagem e criei uma solicitação de cotação para você.", // translated 
  quotationRequestChatMessagePlaceholderStart:
    "Digite sua mensagem para iniciar uma conversa... (Shift+Enter para nova linha)", // translated 
  quotationRequestChatMessagePlaceholder: "Digite sua mensagem... (Shift+Enter para nova linha)", // translated 
  quotationRequestChatUploadFile: "arquivo", // translated 
  quotationRequestChatUploadAttachment: "anexo", // translated 

  quotationRequestChatStopGenerating: "Parar-raio", // translated 
  quotationRequestChatGenerateQuotation: "Gerar cotação", // translated 
  quotationRequestChatGenerateFinalQuotation: "Gerar Cotação Final", // translated 
  quotationRequestChatFinalizeQuotationRequest: "Finalizar Solicitação de Cotação", // translated 
  quotationRequestChatHoldToRecord: "Seguro para gravar mensagem de voz", // translated 
  quotationRequestChatRecordingReleaseToSend: "Gravando, solte para enviar", // translated 
  quotationRequestChatRecording: "Gravando...", // translated 
  quotationRequestChatSelectSessionFirst: "Selecione uma sessão de chat primeiro.", // translated 
  quotationRequestChatCancelVoiceRecording: "Cancelar gravação de voz", // translated 
  quotationRequestChatListening: "acho que...", // translated 
  quotationRequestChatTranscribing: "Tran inscrever...", // translated 

  quotationRequestChatFileUploadedSuccess: "Arquivo enviado com sucesso.", // translated 
  quotationRequestChatUnsupportedFileType: "Tipo de arquivo não suportado. Envie um PDF, Word (.docx), Excel (.xlsx), PowerPoint (.pptx), texto/CSV ou imagem.", // translated
  quotationRequestChatFailedCreateSession: "Falha ao criar sessão de chat. Tente novamente.", // translated 
  quotationRequestChatFailedUploadFile: "Falha ao enviar arquivo. Tente novamente.", // translated 
  quotationRequestChatAnswerPendingBeforeMessage:
    "Responda às perguntas pendentes antes de enviar outra mensagem.", // translated 
  quotationRequestChatAnswerPendingBeforeFinalize:
    "Responda às perguntas pendentes antes de finalizar uma solicitação de cotação.", // translated 
  quotationRequestChatFavoriteMarked: "Sessão de chat marcada como favorita", // translated 
  quotationRequestChatFavoriteUnmarked: "Sessão de chat desmarcada como favorita", // translated 
  quotationRequestChatFailedSetFavorite: "Falha ao marcar como favorita", // translated 
  quotationRequestChatFailedUnsetFavorite: "Falha ao desmarcar como favorita", // translated 
  quotationRequestChatRenamedSuccess: "Sessão de chat renomeada com sucesso.", // translated 
  quotationRequestChatFailedRename: "Falha ao renomear sessão de chat. Tente novamente.", // translated 
  quotationRequestChatDeletedSuccess: "Sessão de chat restaurada com sucesso.", // translated 
  quotationRequestChatFailedDelete: "Falha ao excluir sessão de chat. Tente novamente.", // translated 
  quotationRequestChatAttachmentDeletedSuccess: "Anexo excluído com sucesso.", // translated 
  quotationRequestChatFailedDeleteAttachment: "Falha ao excluir anexo. Tente novamente.", // translated 
  quotationRequestChatSubmittedSuccess:
    "Solicitação de cotação enviada com sucesso! Sua solicitação está sendo processada.", // translated 
  quotationRequestChatFailedSubmit: "Falha ao enviar solicitação de cotação", // translated 
  quotationChatPdfDownloadedSuccess: "PDF baixado com sucesso!", // translated 
  quotationChatFailedGeneratePdf: "Falha ao gerar PDF", // translated 

  quotationRequestChatSubagentRequired:
    "Selecione um usuário subagente antes de enviar uma solicitação de cotação.", // translated 
  quotationRequestChatAppUserLoading:
    "Seu perfil de usuário do CRM ainda está carregando. Tente novamente em instantes.", // translated 
  quotationRequestChatAppUserMismatch:
    "Seu perfil de usuário do CRM não corresponde a esta sessão de chat.", // translated 

  quotationRequestChatRenameTitle: "Renomear Sessão de Chat", // translated 
  quotationRequestChatSessionName: "Nome da Sessão", // translated 
  quotationRequestChatEnterSessionName: "Digite o nome da sessão", // translated 
  quotationRequestChatSaving: "Salvando...", // translated 
  quotationRequestChatSave: "Salvar", // translated 
  quotationRequestChatDeleteTitle: "Excluir Sessão de Chat", // translated 
  quotationRequestChatDeleteConfirm: "Tem certeza de que deseja excluir esta sessão de chat?", // translated 
  quotationRequestChatDeleteCannotUndo: "Esta ação não pode ser desfeita.", // translated 
  quotationRequestChatDeleting: "Excluindo...", // translated 
  quotationRequestChatDelete: "Excluir", // translated 

  quotationRequestChatAttachmentsTitle: "Anexos do Chat de Solicitação de Cotação", // translated 
  quotationRequestChatLoadingAttachments: "Carregando anexos...", // translated 
  quotationRequestChatNoAttachments: "Nenhum anexo encontrado", // translated 
  quotationRequestChatDeleteAttachment: "Excluir anexo", // translated 
  quotationRequestChatUploadingAttachment: "Enviando anexo...", // translated 
  quotationRequestChatUploadingAttachmentWait: "Aguarde enquanto seu arquivo está sendo enviado.", // translated 

  quotationRequestChatAnswerPendingQuestions: "Responder Perguntas Pendentes", // translated 
  quotationRequestChatProposeOwnAnswer: "Propor minha própria resposta", // translated 
  quotationRequestChatTypeOwnAnswerPlaceholder: "Digite sua própria resposta...", // translated 
  quotationRequestChatAnsweredOfTotal: "{{respondidas}} de {{total}} respostas", // translated 
  quotationRequestChatReadyToSubmit: "Pronto para enviar", // translated 
  quotationRequestChatSubmitAll: "Partitura", // translated 
  quotationRequestChatRespondToOneQuestion: "Responder a {{count}} pergunta", // translated 
  quotationRequestChatRespondToManyQuestions: "Respondendo a {{count}} perguntas", // translated 

  quotationRequestChatFinalizeTitle: "Finalizar Solicitação de Cotação", // translated 
  quotationRequestChatLoadingSessionData: "Carregando dados da sessão...", // translated 
  quotationRequestChatErrorLoadingSession: "Erro ao carregar dados da sessão. Tente novamente.", // translated 
  quotationRequestChatQuotationTitle: "Título da Cotação", // translated 
  quotationRequestChatExtraComments: "é", // translated 
  quotationRequestChatSubmitting: "Enviando...", // translated 
  quotationRequestChatSubmit: "🐰", // translated 
  quotationRequestChatSubmittingOverlayTitle: "Enviando solicitação de cotação...", // translated 
  quotationRequestChatSubmittingOverlayDescription:
    "Aguarde enquanto sua solicitação de cotação estiver sendo enviada.", // translated 

  quotationRequestChatSelectSubagent: "subagente", // translated 
  quotationRequestChatSearchSubagents: "Pesquisar subagentes...", // translated 
  quotationRequestChatLoadingSubagents: "Carregando subagentes...", // translated 
  quotationRequestChatNoSubagentsFound: "Nenhum subagente encontrado", // translated 
  quotationRequestChatNoSubagentsAvailable: "Nenhum subagente disponível", // translated 
  quotationRequestChatSelectedSubagent: "somedo: {{label}}", // translated 

  quotationRequestChatSubagentUsers: "Usuários Subagentes", // translated 
  quotationRequestChatSearchUsers: "Pesquisar usuários...", // translated 
  quotationRequestChatNoUsersFound: "Nenhum usuário encontrado", // translated 
  quotationRequestChatNoUsersAvailable: "Nenhum usuário disponível", // translated 

  quotationChatDownloadSummaryTitle: "Baixe o Resumo da Sua Cotação", // translated 
  quotationChatDownloadSummaryDescription:
    "Preencha seus dados abaixo para gerar um resumo em PDF personalizado da cotação de sua viagem. O PDF incluirá todos os detalhes da viagem, destinos, informações de transporte e itinerário dia a dia.", // translated 
  quotationChatCustomerTitle: "Título", // translated 
  quotationChatSelectTitle: "título", // translated 
  quotationChatHonorificMr: "Senhor.", // translated 
  quotationChatHonorificMrs: "Sra.", // translated 
  quotationChatHonorificMs: "Srta.", // translated 
  quotationChatHonorificDr: "Dr.", // translated 
  quotationChatHonorificProf: "Prof.", // translated 
  quotationChatCustomerPhone: "Telefone", // translated 
  quotationChatCustomerCompany: "Empresa", // translated 
  quotationChatCustomerMessage: "Mensagem", // translated 
  quotationChatCustomerCountry: "País", // translated 
  quotationChatGenerating: "Gerando...", // translated 
  quotationChatDownloadPdf: "Baixar PDF", // translated 

  quotationChatTripSummary: "Resumo da Viagem", // translated 
  quotationChatDownloadAsPdf: "Baixar como PDF", // translated 
  quotationChatNoTripSummary: "Nenhum resumo de viagem disponível para esta sessão.", // translated 

  quotationRequestChatThinking: "Pensando...", // translated 
  quotationRequestChatSources: "Fontes", // translated 
  quotationRequestChatSearchingWebFor: 'Pesquisando na web por: "{{query}}"...', // translated 
  quotationRequestChatServicesByTourOperator: "Serviços Executados pelo Operador Turístico", // translated 
  quotationRequestChatServicesByCustomer: "Serviços Tratados pelo Cliente", // translated 
  quotationRequestChatReadyNotice:
    "Agora você pode gerar uma cotação para esta solicitação clicando no botão à direita.", // translated 
  quotationRequestChatGenerateFinalQuotationAria: "Gerar cotação final", // translated 

  quotationRequestChatMaybeYouWantToAsk: "Talvez você queira perguntar:", // translated 
  quotationRequestChatClickToSendSuggestion: "Clique para enviar esta mensagem", // translated 

  quotationRequestChatAddToFavorites: "aos favoritos", // translated 
  quotationRequestChatRemoveFromFavorites: "Remover dos favoritos", // translated 
  quotationRequestChatSubmitted: "Enviado", // translated 

  quotationRequestChatQuotationRequest: "Solicitação de Cotação: {{referência}}", // translated 
  quotationRequestChatQuotationTooltipTitle: "{{título}}", // translated 
  quotationRequestChatQuotationTooltipStatus: "- Status: {{status}}", // translated 

  quotationChatLoading: "Carregando...", // translated 
  quotationChatSessionNotFound: "Sessão de chat não encontrada para esta cotação", // translated 
  quotationChatMemberSessionNotFound: "Sessão de membro não encontrada para sua conta", // translated 
  quotationChatUnableToConnect: "Não foi possível conectar ao chat", // translated 
  quotationChatConnecting: "Conectando...", // translated 
  quotationChatTypeYourMessage: "digite sua mensagem...", // translated 
  quotationChatConnected: "Conectado", // translated 
  quotationChatConnectingStatus: "Conectando...", // translated 
  quotationChatDisconnected: "Desconectado", // translated 
};


export default quotationChat;
